/**
 * Deep clone a template to avoid mutating the cached version.
 * Used when loading offline reviews to prevent on-demand items from polluting the global cache.
 *
 * @param template - A ReviewTemplate object from the cache
 * @returns A deep copy of the template that can be safely mutated
 */
export function cloneTemplate<T>(template: T): T {
  return JSON.parse(JSON.stringify(template));
}
